import React from 'react';
import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../extras/ProtectedRoute';
import JobDashboard from './job-groups/page';
import UpdateJobGroup from './update-job-group/page';
import CreateJobGroup from './create-job-group/page';
import Activities from './activities/page';
import Chat from './chat/page';
import InterviewSchedule from './interview-schedule/page';

export default function JobDashboardV2() {
  return (
    <Switch>
      <ProtectedRoute
        path='/job-dashboardv2/job-groups'
        component={JobDashboard}
      />
      <ProtectedRoute
        path='/job-dashboardv2/update-job-group/:id'
        component={UpdateJobGroup}
        exact
      />
      <ProtectedRoute
        path='/job-dashboardv2/create-job-group'
        component={CreateJobGroup}
        exact
      />
      <ProtectedRoute path='/job-dashboardv2/chat/:id' component={Chat} exact />
      <ProtectedRoute
        path='/job-dashboardv2/interview-schedule'
        component={InterviewSchedule}
        exact
      />
      <ProtectedRoute
        path='/job-dashboardv2/activities'
        component={Activities}
        exact
      />
    </Switch>
  );
}
